<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Consultas — Documentos: Geral
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta consulta lista documentos de
        strong  todos os departamentos
        | , em visão tabular, para busca e impressão.

      .toast.toast-primary
        | Exige a permissão
        strong  Consulta → Documentos → Listar
        | .

      h5.h5 1. Abrir Documentos Geral
      ol
        li Em
          strong  Consultas
          | , abra
          strong  Documentos
          | .
        li Clique em
          strong  Geral (todos departamentos)
          | .

      h5.h5 2. Filtrar e listar
      p
        | Use os filtros (número, ano, departamento, cadastro, datas,
        |  situação etc.). A
        strong  engrenagem
        |  habilita ou desabilita campos; a
        strong  lupa
        |  aplica a busca; a
        strong  impressora
        |  imprime a listagem atual.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem Documentos Geral em Consultas")
      ol
        li Cada linha mostra número/ano, departamento, modelo, cadastro,
          |  datas, situação e valor total.
        li Use a paginação no rodapé quando necessário.

      h5.h5 3. Imprimir um documento
      ol
        li Na coluna de ações, clique no ícone de
          strong  impressora
          | .
        li O PDF do documento abre em uma
          strong  nova aba
          | .
      p
        | Nesta tela não há botão
        strong  Exibir
        |  interno — a consulta é para listagem e impressão.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/22-consultas-docs-geral-lista.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
